import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import EditUser from "../components/EditUsers";


const EditUsers = () => {
  return (
    <>

    

        {/* Breadcrumb */}
        <Breadcrumb title="Edit Users" />

        {/* UsersListLayer */}
        <EditUser />

  

    </>
  );
};

export default EditUsers; 